<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="DEDICATION">To Lauren,<br/>who draws me near,<br/>and gives me room to be free.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?b535b2be